import { useState } from "react";
import { toast } from "react-hot-toast";
import apiClient from "@/lib/config/axiosConfig";
import type { SuccessResponse } from "@/types/api";
import { FeedbackModal } from "./FeedbackModal";

export const FeedbackForm = () => {
	const [isModalOpen, setIsModalOpen] = useState(false);

	const handleOpenModal = () => {
		setIsModalOpen(true);
	};

	const handleCloseModal = () => {
		setIsModalOpen(false);
	};

	const handleFeedbackSubmit = async (feedback: string) => {
		try {
			await apiClient.post<SuccessResponse<{ message: string }>>("/feedback", {
				message: feedback,
			});
			toast.success("Thank you for your feedback!");
		} catch (error) {
			console.error("Error submitting feedback:", error);
			toast.error("Failed to submit feedback. Please try again later.");
		}

		handleCloseModal(); // Close modal after submission
	};

	return (
		<>
			{/* Trigger Button */}
			<button
				type="button"
				onClick={handleOpenModal}
				title="Share Feedback with Us"
				className="fixed bottom-[64px] right-[16px] bg-primary-500 text-white border-0 rounded-full w-12 h-12 flex justify-center items-center shadow-lg cursor-pointer transition-transform duration-200 z-[999] hover:bg-primary-600 focus:outline-none focus:ring-2 focus:ring-primary-400"
				style={{ width: 48, height: 48 }}
			>
				<img src="/icons/feedback.svg" alt="Feedback" className="w-24 h-24" />
			</button>

			{/* Feedback Modal */}
			<FeedbackModal
				isOpen={isModalOpen}
				onClose={handleCloseModal}
				onSubmit={handleFeedbackSubmit}
			/>
		</>
	);
};
